import { render, staticRenderFns } from "./MultiManuscriptEditorFooter.vue?vue&type=template&id=4870ef4e&scoped=true"
import script from "./MultiManuscriptEditorFooter.vue?vue&type=script&lang=ts"
export * from "./MultiManuscriptEditorFooter.vue?vue&type=script&lang=ts"
import style0 from "./MultiManuscriptEditorFooter.vue?vue&type=style&index=0&id=4870ef4e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4870ef4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4870ef4e')) {
      api.createRecord('4870ef4e', component.options)
    } else {
      api.reload('4870ef4e', component.options)
    }
    module.hot.accept("./MultiManuscriptEditorFooter.vue?vue&type=template&id=4870ef4e&scoped=true", function () {
      api.rerender('4870ef4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/MultiManuscriptEditorFooter.vue"
export default component.exports